import { render, staticRenderFns } from "./NewCart.vue?vue&type=template&id=6fc27dda"
import script from "./NewCart.vue?vue&type=script&lang=js"
export * from "./NewCart.vue?vue&type=script&lang=js"
import style0 from "./NewCart.vue?vue&type=style&index=0&id=6fc27dda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports